/**
 * Created by alvinoktavianus on 5/9/17.
 */

export const SETTING_BILLING_BILLINGS = 'SETTING_BILLING_BILLINGS';
export const SETTING_BILLING_PAGE_REQUEST = 'SETTING_BILLING_PAGE_REQUEST';
export const SETTING_BILLING_SET_BILLINGS = 'SETTING_BILLING_SET_BILLINGS';
export const SETTING_BILLING_SET_OUTLETS = 'SETTING_BILLING_SET_OUTLETS';
export const SETTING_BILLING_SET_RULES = 'SETTING_BILLING_SET_RULES';
export const SETTING_BILLING_SET_SUBSCRIPTION_STATUS =
  'SETTING_BILLING_SET_SUBSCRIPTION_STATUS';
export const SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES =
  'SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES';
export const SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES =
  'SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES';
export const SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES =
  'SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES';
export const SETTING_BILLING_PAY_MOKA_SUBSCRIPTION =
  'SETTING_BILLING_PAY_MOKA_SUBSCRIPTION';
export const SETTING_BILLING_PAY_MOKA_SUBSCRIPTION_V2 =
  'SETTING_BILLING_PAY_MOKA_SUBSCRIPTION_V2';
export const SETTING_BILLING_IS_CLICKED_BUTTON_PAY =
  'SETTING_BILLING_IS_CLICKED_BUTTON_PAY';
export const SETTING_BILLING_PAY_BUTTON_MESSAGE =
  'SETTING_BILLING_PAY_BUTTON_MESSAGE';
export const SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL =
  'SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';
export const SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL =
  'SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';
export const SETTING_BILLING_SET_TOTAL_BILLING_PRICE =
  'SETTING_BILLING_SET_TOTAL_BILLING_PRICE';
export const SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE =
  'SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE';
export const SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE =
  'SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE';
export const SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME =
  'SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME';
export const SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION =
  'SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION';
export const SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL =
  'SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
export const SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL =
  'SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
export const SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL =
  'SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
export const SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL =
  'SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
export const SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE =
  'SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE';
export const SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE =
  'SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE';
export const SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION =
  'SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION';
export const SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE =
  'SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE';
export const SETTING_BILLING_ON_CLICK_TURN_BUTTON =
  'SETTING_BILLING_ON_CLICK_TURN_BUTTON';
export const SETTING_BILLING_SET_IS_DELETED_OUTLET =
  'SETTING_BILLING_SET_IS_DELETED_OUTLET';
export const SETTING_BILLING_VERIFY_BILLING_COUPON =
  'SETTING_BILLING_VERIFY_BILLING_COUPON';
export const SETTING_BILLING_SET_STATUS_VALIDATION_COUPON =
  'SETTING_BILLING_SET_STATUS_VALIDATION_COUPON';
export const SETTING_BILLING_SET_COUPON_DISCOUNT =
  'SETTING_BILLING_SET_COUPON_DISCOUNT';
export const SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST =
  'SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST';
export const SETTING_BILLING_SET_COUPON_ERROR_MESSAGE =
  'SETTING_BILLING_SET_COUPON_ERROR_MESSAGE';
export const SETTING_BILLING_UNAPPLY_COUPON_DISCOUNT =
  'SETTING_BILLING_UNAPPLY_COUPON_DISCOUNT';
export const SETTING_BILLING_SET_PURCHASED_STAFFS =
  'SETTING_BILLING_SET_PURCHASED_STAFFS';
export const SETTING_BILLING_SET_IS_EXTENDED_STAFF_SLOTS =
  'SETTING_BILLING_SET_IS_EXTENDED_STAFF_SLOTS';
export const SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS =
  'SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS';
export const SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS_V2 =
  'SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS_V2';
export const SETTING_BILLING_SET_SEPARATE_OUTLET =
  'SETTING_BILLING_SET_SEPARATE_OUTLET';
export const SETTING_BILLING_SET_PROGRESS_CURSOR =
  'SETTING_BILLING_SET_PROGRESS_CURSOR';
export const SETTING_BILLING_SET_EXTEND_DATE =
  'SETTING_BILLING_SET_EXTEND_DATE';
export const SETTING_BILLING_SHOW_PRORATE_TEXT =
  'SETTING_BILLING_SHOW_PRORATE_TEXT';
export const SETTING_BILLING_EXPIRED_DATE = 'SETTING_BILLING_EXPIRED_DATE';
export const SETTING_BILLING_IS_VALIDATING_COUPON =
  'SETTING_BILLING_IS_VALIDATING_COUPON';
export const SETTING_BILLING_SET_DEACTIVE_SUBSCRIPTION =
  'SETTING_BILLING_SET_DEACTIVE_SUBSCRIPTION';
export const SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL =
  'SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL';
export const SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL =
  'SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL';
export const SETTING_BILLING_ON_CLICK_ACTIVE_SUBSCRIPTION =
  'SETTING_BILLING_ON_CLICK_ACTIVE_SUBSCRIPTION';
export const SETTING_BILLING_SET_TOTAL_OUTLET_PRICE =
  'SETTING_BILLING_SET_TOTAL_OUTLET_PRICE';
export const SETTING_BILLING_SET_TOTAL_FEATURES_PRICE =
  'SETTING_BILLING_SET_TOTAL_FEATURES_PRICE';
export const SETTING_BILLING_SET_SHOW_EMPLOYEE_SLOT =
  'SETTING_BILLING_SET_SHOW_EMPLOYEE_SLOT';
export const SETTING_BILLING_SEND_CLEVERTAP = 'SETTING_BILLING_SEND_CLEVERTAP';
export const SETTING_BILLING_SET_PRORATE_PRICE_PERIODS =
  'SETTING_BILLING_SET_PRORATE_PRICE_PERIODS';
export const SETTING_BILLING_SET_STAFF_SLOTS_PRICE =
  'SETTING_BILLING_SET_STAFF_SLOTS_PRICE';
export const SETTING_BILLING_VERIFY_BILLING_COUPON_V2 =
  'SETTING_BILLING_VERIFY_BILLING_COUPON_V2';
export const SETTING_BILLING_SET_DISCOUNT_SETTINGS =
  'SETTING_BILLING_SET_DISCOUNT_SETTINGS';
export const SETTING_BILLING_SET_BILLINGS_CALCULATION =
  'SETTING_BILLING_SET_BILLINGS_CALCULATION';
